import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../components/GenericComponent";
import { ConfiguracionArchivo } from "../../models/administracion/ConfiguracionArchivo";
import { useForm } from "react-hook-form";
import { ConfiguracionArchivoService } from "../../service/admin/ConfiguracionArchivoService";
import { InputComponent } from "../../components/InputComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { TablaDinamica } from "../../components/TablaDinamica";
import { useLazyParams } from "../../hooks/useLazyParams";
import { RolArchivo } from "./RolArchivo";
import { ConfCatalogo } from "./ConfCatalogo";
import { ConfEmpresa } from "./ConfEmpresa";

export const ConfigArchivo = () => {
    const generic = new GenericComponent();
    const omodel = new ConfiguracionArchivo();
    const [permss, setPermss] = useState(null);
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues });
    const archivoSrv = new ConfiguracionArchivoService();
    const toast = useRef(null);
    const menuRef = useRef(null);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const [dialogArchivo, setDialogArchivo] = useState(false);
    const [catalogos, setCatalogos] = useState(null);
    const [archivo, setArchivo] = useState(null);
    const [dialogRol, setDialogRol] = useState(false);
    const [dialogEmpresa, setDialogEmpresa] = useState(false);
    const [dialogCatalogo, setDialogCatalogo] = useState(false);
    const { inDrop, inText, inNumber } = InputComponent({ omodel, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        archivoSrv.getArchivo({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setCatalogos(res.data.catalogos);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const openNew = () => {
        setArchivo(null);
        setDialogArchivo(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            archivoSrv.newArchivo(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogArchivo(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        } else {
            archivoSrv.editarArchivo(data).then(res => {
                generic.funcSuccess(res, toast);
                setDialogArchivo(false);
                loadLazyData();
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const editArchivo = () => {
        archivoSrv.consultarArchivo(archivo?.id).then(res => {
            reset(generic.renewValues(res.data, omodel.model));
            setDialogArchivo(true);
        });
    };

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteArchivo()
        });
    }

    const deleteArchivo = () => {
        archivoSrv.eliminarArchivo(archivo?.id).then(res => {
            generic.funcSuccess(res, toast);
            loadLazyData();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        });
    };

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar) items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editArchivo() } });
        if (permss?.actualizar) items.push({ label: 'Asignar rol', icon: 'pi pi-key', command: () => { setDialogRol(true) } });
        if (permss?.actualizar) items.push({ label: 'Condicionar catálogo', icon: 'pi pi-list-check', command: () => { setDialogCatalogo(true) } });
        if (permss?.actualizar) items.push({ label: 'Condicionar anexo - empresa', icon: 'pi pi-twitch', command: () => { setDialogEmpresa(true) } });
        if (permss?.eliminar) items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise la información ingresada y proceda a corregir.', life: 3000 });
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup onClick={(event) => { setArchivo(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}></Toolbar>
                <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
            </Card>

            <Dialog visible={dialogArchivo} header={getValues('id') == null ? "Nueva configuración" : "Editar configuración"} modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogArchivo(false)}
                style={{ maxWidth: '600px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 12)}
                        {inDrop('tipo_formulario', catalogos?.tipo_formulario, { lab: omodel.optionLabel }, 6)}
                        {inNumber('orden', 0, false, { min: 0 }, 6)}
                        {inDrop('obligatorio', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inDrop('es_revision', generic.sino, { lab: omodel.optionLabel }, 6)}
                        {inDrop('estado', generic.estados, { lab: omodel.optionLabel }, 6)}
                        {inText('nemonicos_obligatorio', {}, 6)}
                        {inText('extension_valida', {}, 6)}
                        {inDrop('mostrar_anexo', generic.sino, { lab: omodel.optionLabel }, 6)}
                    </div>

                    {generic.buttonsForms(setDialogArchivo)}
                </form>
            </Dialog>

            <Dialog visible={dialogRol} header={"Asignar rol al archivo: " + archivo?.nombre} modal className="p-fluid modal-ssize" onHide={() => setDialogRol(false)} style={{ maxWidth: '1200px' }}>
                <RolArchivo id={archivo?.id} toast={toast} permss={permss} generic={generic} />
            </Dialog>

            <Dialog visible={dialogCatalogo} header={"Catálogo obligatorio: " + archivo?.nombre} modal className="p-fluid modal-ssize" onHide={() => setDialogCatalogo(false)} style={{ maxWidth: '500px' }}>
                <ConfCatalogo archivo={archivo} toast={toast} permss={permss} generic={generic} opcion="catalogo" />
            </Dialog>

            <Dialog visible={dialogEmpresa} header={"Anexo obligatorio: " + archivo?.nombre} modal className="p-fluid modal-ssize" onHide={() => setDialogEmpresa(false)} style={{ maxWidth: '700px' }}>
                <ConfEmpresa archivo={archivo} toast={toast} permss={permss} generic={generic} opcion="empresa" />
            </Dialog>
        </>
    )
}
